import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { Account } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/account" component={Account} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Account/routes.js